import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/South';
import KeyboardArrowUpIcon from '@mui/icons-material/North';

import { SortOptions, SortType } from '../../../../enums/SORT';
import styles from './AllContentVideofeedsHeader.module.scss';
import { useDimensions } from '../../../../helpers';
import DateSortHeader from '../../../modules/DateSortHeader';

type TSharedWithMeFoldersHeader = {
  onNameClick?: () => void;
  onSizeClick?: () => void;
  onDateSort?: (_: SortOptions, option: { label: string; value: SortOptions; order: SortType }) => void;
  sort: SortType;
  sortOption: SortOptions;
};

export const AllContentVideofeedsHeader: React.FC<TSharedWithMeFoldersHeader> = ({
  onNameClick,
  sort,
  sortOption,
  onSizeClick,
  onDateSort,
}) => {
  const { widthD } = useDimensions();
  return (
    <div className={styles.videosListHeader} style={{ cursor: 'default' }}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.name} onClick={onNameClick} style={{ cursor: 'pointer' }}>
            Name
            {sortOption === SortOptions.NAME && sort === SortType.ASC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.NAME && sort === SortType.DESC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>
          <div className={styles.owner}>
            Status
            <br />
            Collaborators
          </div>
          <div className={styles.access}>Access</div>
          <div className={styles.uploadedAt}>
            <DateSortHeader
              sortOption={sortOption}
              sort={sort}
              compact={widthD <= 1220}
              onSelect={(value, option) => onDateSort?.(value, option)}
              arrowClassName={styles.arrow}
            />
          </div>
          <div className={styles.fileSize} onClick={onSizeClick} style={{ cursor: 'pointer' }}>
            Size
            {sortOption === SortOptions.SIZE && sort === SortType.ASC && (
              <>
                <KeyboardArrowDownIcon className={styles.arrow} />
              </>
            )}
            {sortOption === SortOptions.SIZE && sort === SortType.DESC && (
              <>
                <KeyboardArrowUpIcon className={styles.arrow} />
              </>
            )}
          </div>

          <div className={styles.duration}> {widthD > 1330 ? 'Upload Hours' : 'Hours'}</div>

          <div className={styles.action}>Actions</div>
        </div>
      </div>
    </div>
  );
};
